const rankings = [
  { rank: 1, title: '流浪地球3', type: '科幻 / 动作', heat: '🔥 9.8', trend: 'up' },
  { rank: 2, title: '庆余年2', type: '古装 / 剧情', heat: '🔥 9.6', trend: 'up' },
  { rank: 3, title: '眼泪女王', type: '爱情 / 剧情', heat: '🔥 9.4', trend: 'up' },
  { rank: 4, title: '怪奇物语5', type: '悬疑 / 科幻', heat: '🔥 9.2', trend: 'stable' },
  { rank: 5, title: '鬼灭之刃 柱训练篇', type: '动画 / 战斗', heat: '🔥 9.1', trend: 'up' },
  { rank: 6, title: '奔跑吧·第8季', type: '综艺 / 真人秀', heat: '🔥 8.9', trend: 'down' },
  { rank: 7, title: '地球脉动3', type: '纪录 / 自然', heat: '🔥 8.7', trend: 'stable' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              实时更新的热播影视排名，看看大家都在追什么
            </p>
          </div>

          <div className="bg-background-800/40 border border-background-700/30 rounded-xl overflow-hidden">
            {rankings.map((item, idx) => (
              <a
                key={item.rank}
                href="#"
                onClick={(e) => e.preventDefault()}
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-800/60 transition-colors cursor-pointer ${
                  idx < rankings.length - 1 ? 'border-b border-background-700/30' : ''
                }`}
              >
                <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-950'
                    : item.rank === 2
                    ? 'bg-accent-500/70 text-background-950'
                    : item.rank === 3
                    ? 'bg-secondary-500/60 text-background-950'
                    : 'bg-background-700/50 text-foreground-400'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm text-foreground-100 font-semibold truncate">{item.title}</h3>
                    {item.trend === 'up' && <i className="ri-arrow-up-line text-xs text-accent-400 flex-shrink-0"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-line text-xs text-foreground-500 flex-shrink-0"></i>}
                    {item.trend === 'stable' && <i className="ri-subtract-line text-xs text-foreground-500 flex-shrink-0"></i>}
                  </div>
                  <p className="text-xs text-foreground-500">{item.type}</p>
                </div>

                <span className="text-sm text-primary-400 font-semibold whitespace-nowrap">{item.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}